// ======================================================================
// File Name       : BoxDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Col, Form, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as boxActions from '../../actions/BoxAction';
import * as containerActions from '../../actions/ContainerAction';
import * as modalActions from '../../actions/ModalAction';
import { Category, Item } from '../../components/Detail';
import TableHead from '../../components/TableHead';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { REDIRECT_MODAL } from '../../constants/BoxConstants';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import * as FunctionConstants from '../../constants/FunctionConstants';
import { START_CONDITION_TYPE_FOR_BOX } from '../../constants/ItemConstant';
import * as ModalIds from '../../constants/ModalIds';
import * as actionTypeContainer from '../../constants/actionTypes/container';
import { SHOW_MESSAGE } from '../../constants/actionTypes/message';
import { canAccess } from '../../utils/AuthedUtils';
import * as courseUtils from '../../utils/CourseUtils';
import UserAttributeDetailConfirmContainer from '../userAttribute/UserAttributeDetailConfirmContainer';

let okBtnClick = false;
class BoxDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.handleEditBtn = this.handleEditBtn.bind(this);
    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.handleOKBtn = this.handleOKBtn.bind(this);
  }

  handleEditBtn() {
    const { dispatch, modalId, box: { editingBox: { itemListForBoxStart } } } = this.props;
    dispatch(containerActions.selectedItemOnDialog(itemListForBoxStart)); // sprint_20230522_tma
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].OK));
  }

  handleBackBtn() {
    const { dispatch, modalId } = this.props;
    dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  handleOKBtn() {
    const { dispatch, modalId } = this.props;
    if (!okBtnClick) {
      okBtnClick = true;
      dispatch(boxActions.saveBox()).then(() => {
        okBtnClick = false;
      }).catch((error) => {
        const messageInfo = {
          statusCd: error.statusCd,
          message: error.message,
          targetModal: true,
          messageType: 'danger',
        };
        dispatch(modalActions.openModal(REDIRECT_MODAL[modalId].CANCEL));
        dispatch({ type: SHOW_MESSAGE, ...messageInfo });
        okBtnClick = false;
      });
    }
  }

  getModalOptions() {
    const { modalId, box } = this.props;

    const boxDetailOption = {
      title: 'セクション詳細',
      footerBtns: [{ name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' }],
    };

    if (canAccess(FunctionConstants.BOX_EDIT) && box.editingBox.dataAffiliationType === DATA_AFFIILIATION_TYPE.INTERNAL) {
      boxDetailOption.footerBtns.push({
        name: '編集',
        onClick: this.handleEditBtn,
        variant: 'primary',
      });
    }

    const OPTIONS = {
      [ModalIds.BOX_DETAIL]: boxDetailOption,
      [ModalIds.BOX_CONFIRM]: {
        title: '以下の内容を登録します',
        footerBtns: [
          { name: '戻る', onClick: this.handleBackBtn, variant: 'default' },
          { name: 'OK', onClick: this.handleOKBtn, variant: 'primary' },
        ],
      },
    };
    return OPTIONS[modalId];
  }

  render() {
    const { box, selectedItemList, structures } = this.props;
    const {
      boxName,
      description,
      publicStatus,
      endConditionTypeForBox,
      defaultThumbnail,
      thumbnailUrl,
      startConditionTypeForBox,
    } = box.editingBox;
    let urlImg = <img src={defaultThumbnail} className="img-thumbnail" width="150" height="150" />;
    if (box.editingBox.thumbnailUrl) {
      urlImg = <img src={thumbnailUrl} className="img-thumbnail" width="150" height="150" />
    }
    if (box.editingBox.imageUploadFile && box.editingBox.dataUrl) {
      const dataUrl = box.editingBox.dataUrl;
      urlImg = <img src={dataUrl} className="img-thumbnail" width="150" height="150" />
    }

    // sprint_20230522_tma START
    const progressRatioForBoxStart = box.editingBox.progressRatioForBoxStart || 0;
    const displayStartConditionTypeForBox = courseUtils.getDisplayStartConditionTypeForBox(startConditionTypeForBox, progressRatioForBoxStart);
    const thead = [
      { title: "コース表示名称", sortBy: null },
      { title: "親セクション名", sortBy: null },
    ];

    let dataTable = null;
    if (selectedItemList && selectedItemList.length) {
      dataTable = selectedItemList.map((cur, index) => {
        let itemNameWithTable = '';
        let boxNameWithItem = '';
        let boxIdWithItem = '';
        if (
          Object.keys(structures.bySecernId).length &&
          structures.bySecernId[cur.itemSecernId]
        ) {
          itemNameWithTable = structures.bySecernId[cur.itemSecernId].structureName;
          boxIdWithItem = structures.bySecernId[cur.itemSecernId].parentBoxSecernId;
          boxNameWithItem = structures.bySecernId[boxIdWithItem].structureName;
        }
        return (
          <tr key={index}>
            <td>{itemNameWithTable}</td>
            <td>{boxNameWithItem}</td>
          </tr>
        );
      });
    }
    const startConditionDataTable = (
      <Table striped hover>
        <thead>
          <TableHead data={thead} />
        </thead>
        <tbody>{dataTable}</tbody>
      </Table>
    );
    // sprint_20230522_tma END

    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal}>
        <Form className='form-horizontal'>
          <Category label="基本設定" />
          <Item name="セクション名" value={boxName} indent={1} />
          <Item name="説明" value={description} indent={1} />
          <Item name="公開ステータス" value={publicStatus === 1 ? '公開' : '非公開'} indent={1} />
          <Item name="サムネイル画像" value={urlImg} indent={1} formClassName="label-middle" />
          <Category label="詳細設定" />
          {/* sprint_20230522_tma START */}
          <Form.Group className="form-info">
            <Col sm={12} className="margin-top-10 padding-left-right-clear">
              <Col sm={3} as={Form.Label} className="padding-left-30">
                セクション開始条件
              </Col>
              <Col sm={9} as={Form.Label}>
                {displayStartConditionTypeForBox}
              </Col>
            </Col>
            {startConditionTypeForBox !== START_CONDITION_TYPE_FOR_BOX.NO_CONDITION && (
              <Col sm={12} className="margin-top-10 padding-left-30">
                {startConditionDataTable}
              </Col>
            )}
          </Form.Group>
          {/* sprint_20230522_tma END */}
          <UserAttributeDetailConfirmContainer titleClass="padding-left-30" leftClass="padding-left-45" />
        </Form>
      </ModalWrapper>
    );
  }
}

BoxDetailContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  box: PropTypes.shape().isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { box, container } = state;
  // sprint_20230522_tma START
  const { structures } = state.container;
  let selectedItemList;
  if (container.selectedItemList && Object.keys(container.selectedItemList).length > 0) {
    selectedItemList = state.container.selectedItemList;
  } else {
    selectedItemList = state.box.selectedItemList;
  }
  return {
    box,
    selectedItemList,
    structures,
  };
  // sprint_20230522_tma END
};
export default connect(mapStateToProps)(BoxDetailContainer);
